import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { ListResultDTO } from '../../../helpers/listResult.interface copy';
import { PopupsDTO, PopupsFilters } from '../../models/popups';
import { toFormData } from '../../../helpers/form.utils';

@Injectable({
    providedIn: 'root',
})
export class LaravelPopupsService {
    constructor(private httpClient: HttpClient) {}

    private get ROUTES() {
        return {
            list: environment.baseUrl + '/api/popups',
            show: environment.baseUrl + '/api/popups',
            store: environment.baseUrl + '/api/popups',
            destroy: environment.baseUrl + '/api/popups',
        };
    }

    public list(
        page: number,
        per_page: number,
        order: string,
        direction: string,
        filters: PopupsFilters,
        includes?: string[]
    ): Observable<ListResultDTO<PopupsDTO>> {
        let params = {};

        if (page) params["page"] = "" + page;
        if (per_page) params["per_page"] = "" + per_page;
        if (order) params["order"] = "" + order;
        if (direction) params["direction"] = "" + direction;
        if (includes) params["includes[]"] = includes;
        if (filters) {
            if (filters.title) params['title'] = filters.title;

            if (filters.tenant_id) params["tenant_id"] = "" + filters.tenant_id;            
        }
        
        if (per_page) {
            params['per_page'] = '' + per_page;
            if (page) params['page'] = '' + page;
            return this.httpClient.get<ListResultDTO<PopupsDTO>>(
            this.ROUTES.list,
            {
                params: new HttpParams({ fromObject: params }),
            }
            );
        } else {
            return this.httpClient
            .get<PopupsDTO[]>(this.ROUTES.list, {
                params: new HttpParams({ fromObject: params }),
            })
            .pipe(
                map((results) => {
                return {
                    data: results,
                    total: results.length,
                };
                })
            );
        }
    }

    public show(id: number): Observable<PopupsDTO> {
    let params = { id: '' + id };
    return this.httpClient.get<PopupsDTO>(this.ROUTES.show, {
        params: new HttpParams({
        fromObject: params,
        }),
    });
    }

    public upsert(popup: PopupsDTO): Observable<PopupsDTO> {
        if (popup.id) {
            return this.httpClient.post<PopupsDTO>(`${this.ROUTES.store}/${popup.id}`,
            toFormData(popup, true),
        );
        } else {
            return this.httpClient.post<PopupsDTO>(`${this.ROUTES.store}`,
            toFormData(popup),
            );
        }
    }

    public delete(id: number) {
    let params = new HttpParams().set("id", "" + id);
    return this.httpClient.delete(this.ROUTES.destroy + "/" + id);
    }
    

}